import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import { duration } from "@mui/material";

const BarChart = ({ chartData, xKey, yKey }) => {
  
  const data = {
    labels: chartData.data.map((item) => item[xKey]),
    datasets: [
      {
        label: "Dataset",
        data: chartData.data.map((item) => item[yKey]),
        backgroundColor: "#1976D2",
      },
    ],
  };

  const options = {
    animation: false,
    responsive: true,
    maintainAspectRatio: false, 
    plugins: {
      legend: { display: false },
    },
    scales: {
      x: { title: { display: true, text: xKey, }, },
      y: { title: { display: true, text: yKey, }, },
    },
  };

  return <Bar data={data} options={options} />;
};

export default BarChart;
